// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/component/componentScriptService.js#1 $
//'use strict';

/**
* @ngdoc service
* @name tcApp.ComponentScriptService
* @description
* This service adds all necessary custom component scripts to component controller, 
* including legacy scripts if needed
*
*/
angular.module('tcApp').factory('ComponentScriptService', function(
								$log, $window, $document, $http, $timeout, $location, $q, $rootScope,
								GlobalService, LegacyScopeService, TkLibService) { 
	// This function builds a list of all local variables custom scripts may use
	var getLocalVariableList = function($scope) {
		var v = {};
		v.document = 'LegacyScopeService.getDocument(this)';
		v.window = 'LegacyScopeService.getWindow(this)';
		v.session = 'LegacyScopeService.getSession(GlobalService)';
		v.t = 'angular.extend({},this.globalStrings,this.data.translations)';
		v.focusat = 'null';
		v.compid = $scope.data.componentId;
		v.emptyFunction = 'function(){}';
		v['websys_windows'] = '[]';
		// 'lu_obj' is defined in global scope
		v.$scope = 'this';
		
		if (angular.isDefined(GlobalService.configuration)
			&& angular.isDefined(GlobalService.configuration.currency)) {
			v.curydecimalsym = '\'' + GlobalService.configuration.currency.decimalSymbol + '\'';
			v.curygroupsym = '\'' + GlobalService.configuration.currency.groupingSymbol + '\'';
		}

		var legacyFunctions = LegacyScopeService.getLegacyFunctions($scope);
		angular.forEach(legacyFunctions, function(functionCode, functionName) {
			v[functionName] = 'this.' + functionName;
		});
		
		// Some items used to have have _click and _changehandler generated functions
		// And some legacy scripts use those.
		angular.forEach($scope.data.items, function(item, itemName) {
			// Script cannot execute with dots in variable names
			itemName = itemName.replace(/\./g, '_');
			v[itemName + '_changehandler'] = 'this.emptyFunction';
			if (['A','B'].indexOf(item.displayType) !== -1) {
				v[itemName + '_click'] = 'this.buttonClickHandler';
			}
			if (item.displayType === 'A') {
				v[itemName + '_return'] = 'this.linkReturnHandler';
			}
		});
		if (angular.isDefined($scope.data.ssoData)) {
			v.tkSSOData = '$scope.data.ssoData';
		}
		
		return v;
	};

	// this builds one long function from multiple script files and adds 
	// a command to place it into window's global context.
	// we'll remove it later from window in runScripts function.
	var getScriptFunction = function($scope, functionName, source, dependencies, localVariables) {
		var script = '';
		var isMenuScript = (functionName.indexOf('menuScript') === 0);
		
		script += 'window.' + functionName + ' = function(' + dependencies + ') {\n';
		// Component script should only be called once, but it is possible to add a check on $scope.$$destroyed
		
		// Declare all possible local variables.
		angular.forEach(localVariables, function(value, name) {
			script += 'var ' + name + ' = ' + value + ';\n';
			if ((angular.isUndefined(value)) || (value.toString() !== ('this.' + name))) {
				// Properties on the 'this' object are declared in the function closure by tkLib.Injection
				script += 'if (typeof this.' + name + ' === \'undefined\') this.' + name + ' = ' + name + ';\n';
			}
		});
		// Define tkLib and $scope explicitly for menu scripts
		if (isMenuScript) {
			script += 'var $scope = this;\n';
			script += 'var tkLib = $ = TkLibService.getTkLib(this);\n';
		}

		if (source !== '') {
			// Only necessary where tkLib Injection is used.
			// May be extended to the other source modifications later
			if (source.indexOf('tkLib.Injection(') !== -1) {
				// Use parser for proper identifications of variable declarations
				let ast = {};
				try {
					ast = $window.esprima.parseScript(source, {tolerant: true, comment: true});
				} catch (ex) {
					ast.errors = [ex];
				}
				if (ast.errors?.length > 0) {
					$log.error('Error parsing component script for tkLib.Injection:', ast.errors);
					$log.error('Source:', source);
					const errorSourceName = ($scope.componentHtmlName ?? $scope.componentName ?? $scope.id);
					$window.alert(`Error loading JavaScript for source: ${errorSourceName}`);
				} else {
					ast = addRootVariablesToScope(ast);
					// Use code generator to generate the modified source
					try {
						source = $window.astring.generate(ast);
					} catch (ex) {
						$log.error('Error generating source for tkLib.Injection:', ex);
						const errorSourceName = ($scope.componentHtmlName ?? $scope.componentName ?? $scope.id);
						$window.alert(`Error loading JavaScript for source: ${errorSourceName}`);
					}
				}
			}
			source = addFunctionsToScope(source);
			source = addScopeToIIFE(source);
			source = addTkLibExposedFunctionDeclarations(source);
		}
		script += source;
		script += '} \n';
		
		// This allows to display scripts nicely in debug window
		if (isMenuScript) {
			script += '//# sourceURL=/menuScript/' + $scope.$id + '.js\n';
		} else {
			var sourceMapName = (angular.isDefined($scope.componentName) ? $scope.componentName : $scope.$id);
			script += '//# sourceURL=/componentScript/' + sourceMapName + '.js\n';
		}

		return script;
	};

	// Declare top level variables on the 'this' object, so they can be picked up
	// by tkLib.Injection and declared for injected functions
	var addRootVariablesToScope = function(ast) {
		if (!ast.body) return ast;
		let errored = false;

		angular.forEach(ast.body, function(node, nodeIndex) {
			if (errored) return;
			if ((node.type === 'VariableDeclaration') && (node.declarations)) {
				angular.forEach(node.declarations, function(nodeDec) {
					if ((nodeDec.type === 'VariableDeclarator')
						&& (nodeDec.id) && (nodeDec.id.name !== '')) {
						// Construct and parse the line of code, then modify the ast
						var injectCode = ('if (typeof this.' + nodeDec.id.name + ' === \'undefined\')'
								+ ' this.' + nodeDec.id.name + '=' + nodeDec.id.name + ';');
						try {
							injectCode = $window.esprima.parseScript(injectCode);
						} catch (ex) {
							errored = true;
							$log.error('Error parsing injected code for addRootVariablesToScope:', ex);
							$log.error('Source:', injectCode);
							$window.alert(GlobalService.getGlobalStrings()?.['XERROR'] ?? 'Error loading JavaScript');
							return;
						}
						ast.body.splice((nodeIndex + 1), 0, injectCode);
					}
				});
			}
		});
		
		return ast;
	};
	
	// This function adds declared functions to scope.
	// it replaces function definition like "function blabla(a,b,c) {" with
	// "if (typeof blabla=='function') this.blabla=blabla; function blabla(a,b,c) {"
	// That allows us to use those functions later in templates, handlers, etc
	var addFunctionsToScope = function(source) {
		var newSource = '\nif (typeof $1 === \'function\') {this.$1=$1;}\n$&';
		source = source.replace(/^\s*function\s+(\w+)\s*\(.*$/gm, newSource);

		return source;
	};
	
	// Modifies any IIFE calls so that they are executed with the 'this' context being the component scope
	//
	//	(function(){ ... })();		=>		(function(){ ... }).call($scope);
	//	(function(){ ... }());		=>		(function(){ ... }.call($scope));
	var addScopeToIIFE = function(source) {
		// Replace the first variation of an IIFE ending expression: })();
		var regexFunctionEnd1 = /\}\s*\)\s*\(\s*\)/g;
		source = source.replace(regexFunctionEnd1, '}).call($scope)');

		// Replace the second variation of an IIFE ending expression: }());
		var regexFunctionEnd2 = /\}\s*\(\s*\)\s*\)/g;
		source = source.replace(regexFunctionEnd2, '}.call($scope))');
		
		return source;
	};
	
	// For tkLib.exposeInScope, parse the source to define the functions directly as variables
	// before call to exposeInScope function
	// e.g. For component MyComponent.Sub.SubSub:
	//
	//	var MyComponent = {Sub: {SubSub: {}}};
	//	MyComponent.Sub.SubSub = this.MyComponent.Sub.SubSub.CustomFunction;
	//	var CustomFunction=this.MyComponent.Sub.SubSub.CustomFunction;
	var addTkLibExposedFunctionDeclarations = function(source) {
		var exposedFnSource,newSource,exposedObject,exposedObjectName;
		var regexForInsertResult,sourceToFindInsert;
		// Regex to find the first instance of "$(document).ready(function(" OR "tkLib.exposeInScope("
		var regexForInsert = /^\s*(?:(?:\$\(\s*document\s*\)\s*.\s*ready\s*\(\s*function\s*\()|(?:tkLib\s*\.\s*exposeInScope\s*\())/m;
		
		var prevIndex = 0;
		var regexExposeInScope = /tkLib\s*\.\s*exposeInScope\s*\(\s*\[/g;
		while (regexExposeInScope.exec(source) !== null) {
			exposedFnSource = source.substring(regexExposeInScope.lastIndex);
			exposedFnSource = exposedFnSource.split('])')[0];
			if (exposedFnSource === '') continue;
					
			newSource = '';
			exposedObject = null;
			angular.forEach(exposedFnSource.split('}'), function(nameValue) {
				nameValue = nameValue.split('{')[1];
				if ((angular.isUndefined(nameValue)) || (nameValue === '')) return;
				// Strip out any quotes
				nameValue = nameValue.replace(/'|"/g, '');
				
				var functionName = nameValue.split('name:')[1];
				var functionValue = nameValue.split('value:')[1];
				if ((angular.isDefined(functionName)) && (angular.isDefined(functionValue))) {
					functionName = functionName.split(',')[0].trim();
					functionValue = functionValue.split(',')[0].trim();
					if ((functionName !== '') && (functionValue !== '')) {
						if (exposedObject === null) {
							// Define the top level object once
							var functionValueArray = functionValue.split('.');
							exposedObjectName = functionValueArray[0];
							if (exposedObjectName !== '') {
								// Remove the function name when defining the top level object
								functionValueArray.pop();
								functionValueArray = functionValueArray.join('.');
								if (functionValueArray === '') return;
								exposedObject = TkLibService.getNamespaceObject(functionValueArray, {});
								newSource += ('var ' + exposedObjectName + '='
													+ angular.toJson(exposedObject[exposedObjectName]) + ';\n');
							}
						}
						// Then define the functions on the object.
						// This is required for exposeInScope calls that reference the namespace object
						// Functions are set onto 'this' in exposeInScope
						if (exposedObject !== null) {
							newSource += (functionValue + '=this.' + functionValue + ';\n');
						}
						// Expose the functions directly within the lexical scope (for use in handlers)
						newSource += ('var ' + functionName + '=this.' + functionValue + ';\n');
					}
				}
			});
			if (newSource !== '') {
				newSource = ('\n' + newSource);
				// Find the first instance of $(document).ready / tkLib.exposeInScope AFTER the previous tkLib.exposeInScope
				// to insert the declarations
				sourceToFindInsert = source.substring(prevIndex, regexExposeInScope.lastIndex);
				if ((sourceToFindInsert !== '')
					&& ((regexForInsertResult = regexForInsert.exec(sourceToFindInsert)) !== null)) {
					source = (source.substring(0, (prevIndex + regexForInsertResult.index - 1))
							+ newSource + source.substring(prevIndex + regexForInsertResult.index));
				}
			}
			prevIndex = (regexExposeInScope.lastIndex + newSource.length);
		}
		
		return source;
	};

	var runScripts = function($scope, source) {
		var functionName = 'componentScript' + $scope.$id;
		var localVariables = getLocalVariableList($scope);
		var scriptFunction = getScriptFunction($scope, functionName, source,
												'LegacyScopeService,GlobalService', localVariables);
		
		// this function is defined in scripts/legacy.js
		// we need it to run component scripts in non-strict mode.
		// this allows scripts to pollute global context instead of getting undefined errors
		// if somebody forgets to declare variable using var keyword.
		$window.tcEvalNonStrictMode(scriptFunction);

		$window[functionName].call($scope, LegacyScopeService, GlobalService);
		delete $window[functionName];
	};

	var allNestedItemsInitialised = function($scope) {
		var allInitialised = true;
		angular.forEach($scope.data.items, function(item) {	
			if (item.displayType == 'CX' && angular.isDefined(item.componentData)) {
				// Check that component controller was initialised
				var componentFound = false;
				var callFunction = function callFunction() {
					componentFound = true;
				};
				// Find the first matching component down the tree
				$scope.$broadcast('Component:getComponentHtmlName', item.nestedComponentName, callFunction);
				if (!componentFound) allInitialised = false;
				//check if items were tweaked by examining TFORM item which is always present on component
				if ((angular.isDefined(item.componentData.items))
					&& (angular.isUndefined(item.componentData.items.TFORM.getAttribute))) {
					allInitialised = false;
				}
			}
			
		});
		return allInitialised;
	};
	
	var setItemInvalidOnLoad = function($scope, item) {
		$timeout(function setItemInvalidOnScriptDone() {
			if (angular.isDefined($scope.componentForm[$scope.componentHtmlName]))  {
				$scope.componentForm[$scope.componentHtmlName][item.id].$setValidity('invalid', false);
				$scope.componentForm[$scope.componentHtmlName][item.id].$tcInvalidOnLoad = true;
			}
		}, 100);
	};

	var applyScripts = function($scope, scripts) {
		var httpPromises = [];
		var httpConfig = {cache: true};
		angular.forEach(scripts, function(value) {
			httpPromises.push($http.get(value, httpConfig));
		});
		$q.all(httpPromises).then(function(results) {
			// Apply legacy functions to scope
			LegacyScopeService.tweakItems.call($scope, $scope);
			var legacyFunctions = LegacyScopeService.getLegacyFunctions($scope);
			angular.forEach(legacyFunctions, function(functionCode, functionName) {
				$scope[functionName] = functionCode;
			});

			var allScripts = '';
			angular.forEach(results, function(value) {
				allScripts += '\n\n//////////////////////\n// ' + value.config.url + '\n//////////////////////\n\n';
				allScripts += value.data + '\n';
			});

			LegacyScopeService.clearLocationRedirect();
			runScripts($scope, allScripts);
			if (LegacyScopeService.getLocationRedirect() != '') {
				$location.url(LegacyScopeService.getLocationRedirect());
			}
			// Run lookup and OnChange JS functions for any fields with default expressions
			angular.forEach($scope.data.items, function(item) {
				if (item.brokerRanOnLoad) {
					if ((angular.isDefined(item.runJSFunctionOnLoad)
						&& (angular.isFunction($scope[item.runJSFunctionOnLoad])))) {
						$scope[item.runJSFunctionOnLoad](item.runJSFunctionOnLoadParam);
					}
					// Run the OnChangeJSFunction after the lookup JS function,
					// and regardless of whether there is a lookup JS function
					$scope.itemChangeHandler(item);
				} else if ((item.invalidOnLoad) && (item.value !== '')) {
					setItemInvalidOnLoad($scope, item);
				}
			});
			// if there is an edit form on component, set it to pristine state after scope digest.
			// Needs to be executed after the component script has finished
			$timeout(function() {
				if (angular.isDefined($scope.componentForm[$scope.componentHtmlName])) {
					// Set the component as dirty if it was previously set in component cache
					if ((angular.isDefined($scope.data.items))
						&& (angular.isDefined($scope.data.items['TDIRTY']))
						&& ($scope.data.items['TDIRTY'].value == true)) {
						$scope.componentForm[$scope.componentHtmlName].$setDirty();
					} else {
						// Set to pristine because component script can modify form items.
						$scope.componentForm[$scope.componentHtmlName].$setPristine();
					}
				}
			}, 100);
			
			// Send a signal that scripts are executed
			$rootScope.$broadcast('componentScript:runScripts', $scope);
		});
	};
	
	return {
		applyScripts: applyScripts,
		allNestedItemsInitialised: allNestedItemsInitialised,
		runScripts: runScripts,
		getScriptFunction: getScriptFunction,
	};
});
